import request from '@/utils/request'


export function fetchGate (params){
    return request({
        url: '/gateData/gates',
        method: 'get',
        params: params,
    })
}

export function createGate (data) {
  return request({
    url: '/gateData/gates',
    method: 'post',
    data: data
  })
}

export function updateGate (id, data) {
  return request({
    url: `/gateData/gates/${id}`,
    method: 'put',
    data: data
  })
}

export function deleteGate (id) {
  return request({
    url: `/gateData/gates/${id}`,
    method: 'delete',
  })
}

// ============================================================================


export function fetchCarList(params){
    return request({
        url: '/gateData/carsByGateId',
        method: 'get',
        params: params,
    })
}


export function fetchCars(params){
    return request({
        url: '/gateData/cars',
        method: 'get',
        params: params,
    })
}


export function createCar (data) {
  return request({
    url: '/gateData/cars',
    method: 'post',
    data: data
  })
}

export function updateCar (id, data) {
  return request({
    url: `/gateData/cars/${id}`,
    method: 'put',
    data: data
  })
}

export function deleteCar (id) {
  return request({
    url: `/gateData/cars/${id}`,
    method: 'delete',
  })
}


// ============================================================================


export function fetchDrivers(params){
    return request({
        url: '/gateData/drivers',
        method: 'get',
        params: params,
    })
}


export function createDriver (data) {
  return request({
    url: '/gateData/drivers',
    method: 'post',
    data: data
  })
}

export function updateDriver (id, data) {
  return request({
    url: `/gateData/drivers/${id}`,
    method: 'put',
    data: data
  })
}

export function deleteDriver (id) {
  return request({
    url: `/gateData/drivers/${id}`,
    method: 'delete',
  })
}

// ============================================================================


export function fetchWtUnit(){
    return request({
        url: '/gateData/wtUnits',
        method: 'get',
    })
}

export function fetchBranchList(params){
    return request({
        url: '/gateData/branches',
        method: 'get',
        params: params,
    })
}

export function fetchMenuList(params){
    return request({
        url: '/gateData/menus',
        method: 'get',
        params: params,
    })
}

export function fetchTownshipList(){
    return request({
        url: '/gateData/townships',
        method: 'get',
    })
}

export function fetchGrnCountByDate(params){
    return request({
        url: '/gateData/grnCountByDate',
        method: 'get',
        params: params,
    })
}